import { Column } from "../decorators/column.decorator";
import { Model } from "../decorators/model.decorator";
import { BaseModel } from "./base.model";

@Model('paymentPayload')
export class PaymentPayload extends BaseModel {
  @Column()
  payload: string | undefined;

  unpack(): any {
    if (this.payload) {
      return JSON.parse(window.atob(this.payload))
    } else {
      return undefined
    }
  }
}
